import { AxiosError } from "axios";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import axioInstance from "@/libs/axios";
import { RootState } from "@/store/root-reducer";
import { QuoteData } from "@/types/quote/quote-data";
import logError from "@/utils/logger";

type QuoteResponse = {
  data: {
    data: QuoteData;
  };
};

// Custom hook for fetching data
export default function useFetchQuoteData(
  quoteRef?: string | null,
  affiliate?: string | null,
  policy?: string | null,
  isInitFetch?: boolean
) {
  const [data, setData] = useState<null | QuoteData>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<null | AxiosError>(null);
  const { referenceId } = useSelector((state: RootState) => state.quote);

  useEffect(() => {
    const fetchQuoteData = async () => {
      try {
        let getQuoteUrl = `${process.env.NEXT_PUBLIC_BASE_URL}/quote`;
        if (quoteRef && affiliate) {
          const application = process.env.NEXT_PUBLIC_APPLICATION;
          if (application === "renewal" && isInitFetch) {
            getQuoteUrl = `${getQuoteUrl}/${quoteRef}`;
          } else {
            getQuoteUrl = `${getQuoteUrl}/${quoteRef}${
              affiliate ? `?affiliate=${affiliate}` : ""
            }`;
          }

          await axioInstance.post(`/createCookie`);
        }
        if (policy) {
          getQuoteUrl = `${getQuoteUrl}?policy=true`;
        }
        const response: QuoteResponse = await axioInstance.get(getQuoteUrl, {
          params: { t: new Date().getTime() },
        });

        setData(response.data.data);
      } catch (err) {
        logError(err as AxiosError, { location: "Get Quote" });
        const axiosError = err as AxiosError;
        setError(axiosError);
      } finally {
        setLoading(false);
      }
    };
    if (referenceId === "" || isInitFetch) {
      fetchQuoteData();
    } else {
      setLoading(false);
    }
  }, [referenceId, quoteRef, affiliate, policy, isInitFetch]);

  return { data, loading, error };
}
